module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_9005.34e82b68.png";